<template>
  <div>
    <div class="thank-you-container">
      <p class="ty__note">Thank you for your donation</p>
    </div>
  </div>
</template>

<style scoped>

.thank-you-container {
  padding: 20px;
  min-height: 300px;
  margin: 0 auto;
  background: #dff9e1;
  color: black;
  line-height: 1.4;
  font-weight: 400;
  text-align: left;
}

.ty__note {
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.dd__wrap {
  max-width: 550px;
  margin: 0 auto 20px;
}
</style>
